<template>
  <div class="item" id="examples1">
    <div class="item-header">
      <div class="item-header-title">OUR CUSTOMERS</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>我们的</span>
        <span class="bold">客户</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">安易信核心团队拥有15年+的从业经验，已服务200+医疗数据中心建设案例、100+大中型企业数据中心建设案例、100+其他行业数据中心建设案例</div>
    </div>

    <div class="item-content">
      <div class="scroll">
        <div class="scroll-content">
          <div class="scroll-wrap" :style="getWrapStyle">
            <div class="scroll-items" v-for="(child,i) in customerList" :key="`child-${i}`">
              <div class="scroll-item" v-for="(item,j) in child" :key="`${i}-${j}`">
                <img :src="item" />
              </div>
            </div>
          </div>
        </div>
        <div class="scroll-bottom">
          <div
            :class="getLeftClasses"
            @click="prevSolution" />
          <div
            :class="getRightClasses"
            @click="nextSolution" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCustomerData } from '../../services'

export default {
  data () {
    return {
      solutionPage: 0,
      customerList: []
    }
  },

  created () {
    getCustomerData().then(res => {
      let customerList = []
      res.data.data.data.children.forEach((item, i) => {
        const page = Math.floor(i / 10)
        const index = i % 10
        if (!customerList[page]) {
          customerList[page] = []
        }
        customerList[page][index] = 'http://tarzan.minus.live' + item.img
      })
      this.customerList = customerList
    })
  },

  methods: {
    nextSolution () {
      if (this.solutionPage <= this.customerList.length - 2) {
        this.solutionPage += 1
      }
    },

    prevSolution () {
      if (this.solutionPage > 0) {
        this.solutionPage -= 1
      }
    },

    getWidth () {
      let translateX = 726
      const width = document.body.getBoundingClientRect().width
      if (width > 1280 && width <= 1680) {
        translateX = 1089
      } else if (width >= 1920) {
        translateX = 1452
      }
      return translateX
    }
  },

  computed: {
    getSolutionScrollItemsStyle () {
      const translateX = this.getWidth()
      return {
        transform: `translateX(${this.solutionPage * -translateX}px)`
      }
    },

    getWrapStyle () {
      const translateX = this.getWidth()
      return {
        width: translateX * this.customerList.length + 'px',
        transform: `translateX(${this.solutionPage * -translateX}px)`
      }
    },

    getLeftClasses () {
      return `scroll-btn scroll-left ${this.solutionPage === 0 ? '' : 'active'}`
    },

    getRightClasses () {
      return `scroll-btn scroll-right ${this.solutionPage === this.customerList.length - 1 ? '' : 'active'}`
    }
  }
}
</script>

<style lang="less" scoped>
.scroll {
  display: flex;
  align-items: center;
  flex-direction: column;
  &-bottom {
    display: flex;
    padding: 20px;

    @media (min-width: 1280px) and (max-width: 1680px){
      padding: 30px;
    }
          
    @media screen and (min-width: 1920px){
      padding: 40px;
    }
  }
  &-btn {
    width: 30px;
    height: 30px;
    cursor: pointer;
    margin: 0 20px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 45px;
      height: 45px;
      margin: 0 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 60px;
      height: 60px;
      margin: 0 40px;
    }
  }
  &-left {
    background: url('../../assets/images/left_arrow.png');
    background-size: 100% 100%;
  }
  &-right {
    background: url('../../assets/images/right_arrow.png');
    background-size: 100% 100%;
  }
  &-left.active {
    background: url('../../assets/images/left_arrow_active.png');
    background-size: 100% 100%;
  }
  &-right.active {
    background: url('../../assets/images/right_arrow_active.png');
    background-size: 100% 100%;
  }
  &-content {
    width: 726px;
    margin: 0 20px;
    overflow: hidden;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 1089px;
      margin: 0 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1452px;
      margin: 0 40px;
    }

    .scroll-wrap {
      display: flex;
      transition: all .5s ease-in-out;
    }

    .scroll-items {
      width: 726px;
      display: flex;
      flex-wrap: wrap;
      @media (min-width: 1280px) and (max-width: 1680px){
        width: 1089px;
      }
            
      @media screen and (min-width: 1920px){
        width: 1452px;
      }
      .scroll-item {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 135px;
        height: 85px;
        margin: 0 5px 10px 5px;
        border: 1px dashed #d3d3d3;
        transition: all .5s ease-in-out;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 202.5px;
          height: 127.5px;
          margin: 0 7.5px 15px 7.5px;
          border-width: 1.5px;
        }
              
        @media screen and (min-width: 1920px){
          width: 270px;
          height: 170px;
          margin: 0 10px 20px 10px;
          border-width: 2px;
        }
        img {
          width: 100%;
          height: 100%;
        }

        &-btn {
          width: 96px;
          height: 28px;
          border-radius: 14px;
          background-color: #f45937;
          color: #fff;
          font-size: 9px;
          line-height: 28px;
          text-align: center;
          margin-top: 20px;
          transition: all .5s ease-in-out;

          @media (min-width: 1280px) and (max-width: 1680px){
            width: 144px;
            height: 42px;
            border-radius: 21px;
            font-size: 14px;
            line-height: 42px;
            margin-top: 30px;
          }
                
          @media screen and (min-width: 1920px){
            width: 192px;
            height: 56px;
            border-radius: 28px;
            font-size: 18px;
            line-height: 56px;
            margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>